import { Injectable } from '@angular/core';
import { Criterion } from './criterion'
import { ArcService } from './arc.service'
import { UtilsService } from './utils.service'
import { Observable }  from 'rxjs/Observable';
import { RuntimeService } from './runtime.service'
import { ProjectService } from './project.service'
import { DbRecordService } from './db-record.service'
import { CriterionItem } from './criterion-item'
import { Project } from './project'
import { DbRecord } from './db-record'

@Injectable()
export class CriterionService {
  _tempCriterionItemValues = new Map<string, string[]>()
  private _ciCounter = 1
  currentCriterion: Criterion

  constructor(
    private arcs: ArcService,
    private rts: RuntimeService,
    private utils: UtilsService,
    private projects: ProjectService,
    private dbrs: DbRecordService
  ) {
    this.arcs.cs = this
    this.projects.cs = this
    this.dbrs.cs = this
  }

  newFromSaved(p: Project, params: Object) {
      let c = new Criterion(this, p, params['id'], params['title'])
      params['items'].forEach((tpl) => this.addItem(c, tpl[0], tpl[1]))
  }

  newCriterion() {
    let cid = this.utils.uniqueIdentifier
    if (!cid)
      return
    return new Criterion(this, this.rts.currentProject, cid, '')
  }

  addItem(c: Criterion, rg?:string, w?:(string|number)) {
    rg = rg || null
    if (typeof w == 'string')
      w = parseFloat(w)
    let  wght = w || 1
    return new CriterionItem(this, c, `ci${this._ciCounter++}`, rg, wght)
  }

  clearCriterionItemValues() {
    this._tempCriterionItemValues.clear()
  }

  clearRecordCache(dbRecord: DbRecord) {
    this.rts.currentProject.criterionsMap.forEach((x) => {
      x.run(dbRecord, true)
    })
  }

  get(id: string) {
    return this.rts.currentProject.criterionsMap.get(id)
  }

  get criterionItemValues() {
    return this._tempCriterionItemValues
  }

  initCIvalues(ci: CriterionItem, rg: string, w: string) {
    this._tempCriterionItemValues.set(ci.id, [rg, w])
  }

  setCIregexp(ci: CriterionItem, rg: string) {
    this._tempCriterionItemValues.get(ci.id)[0] = rg
  }

  setCIweight(ci: CriterionItem, w: string) {
    this._tempCriterionItemValues.get(ci.id)[1] = w
  }

  getCIregexp(ci: CriterionItem) {
    return this._tempCriterionItemValues.get(ci.id)[0]
  }

  getCIweight(ci: CriterionItem) {
    return this._tempCriterionItemValues.get(ci.id)[1]
  }

  save(c: Criterion): Observable<any>  {
    c.isNew = false
    let ciLs = []
    c.itemsSet.forEach((x) => {
      let tpl = this.criterionItemValues.get(x.id)
      if (!tpl[0] || !tpl[1]) {
        x.delete()
        return
      }

      x.regexp = tpl[0]
      x.weight = tpl[1]
      ciLs.push(tpl)
    })
    c.clear()
    let obs = this.arcs.run({
      fun: 'saveCriterion',
      title: c.title,
      projectId: c.project.id,
      id: c.id,
      items: ciLs
    })
    obs.subscribe((resp) => {
      console.log(41144114, resp)
    })

    return obs
  }


  delete(c: Criterion): Observable<any> {
    let obs = this.arcs.run({
      fun: 'deleteCriterion',
      id: c.id
    })
    obs.subscribe((resp) => c.project.criterionsMap.delete(c.id))
    return obs
  }

}



// WEBPACK FOOTER //
// ./src/app/criterion.service.ts